import React from 'react';


const CollegeSection = ({ title, colleges }) => {
  return (
    <div className="college-section">
      <h2 className="college-title">{title}</h2>
      <div className="college-cards-container">
        {colleges.map((college, index) => (
          <div key={index} className="college-card w3-card">
            <div className="card-image">
              <img src={college.imgSrc} alt={college.name} />
            </div>
            <div className="card-content">
              <h3 className="college-name">
                <a href={college.link}>
                  {college.name}
                </a>
              </h3>
              <p className="college-description">{college.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Home = () => {
  const yuvrajColleges = [
    {
      name: 'Yuvraj College of Pharmacy, Batta (D.Pharma)',
      imgSrc: 'pharm-thumb.jpg',
      link: 'https://yuvrajgroupofinstitute.com/pharmacy',
      description: 'The Yuvraj College of Pharmacy offers a comprehensive D.Pharma program designed to provide students with the essential skills and knowledge needed for a successful career in pharmacy.'
    },
    {
      name: 'Yuvraj College of Physical Education Batta (B.P.Ed)',
      imgSrc: 'ybed-thumb.jpg',
      link: 'https://yuvrajgroupofinstitute.com/ycpe',
      description: 'The Yuvraj College of Physical Education provides students with a B.P.Ed degree, focusing on sports science, physical fitness, and educational methodologies in physical education.'
    },
    {
      name: 'Yuvraj MPHW (M). Training School Batta',
      imgSrc: 'mp-thumb.jpg',
      link: 'https://yuvrajgroupofinstitute.com/ymts',
      description: 'The Yuvraj MPHW (M) Training School trains students in the medical field, offering various courses designed to prepare them for roles in health care and public health services.'
    },
    {
      name: 'Yuvraj Public School Batta (CBSE affiliated)',
      imgSrc: 'yps-thumb.jpg',
      link: 'https://yuvrajgroupofinstitute.com/yps',
      description: 'Yuvraj Public School, affiliated with CBSE, offers quality education with a focus on academics, extracurricular activities, and all-round development of students.'
    },
    {
      name: 'Yuvraj Pvt. ITI Batta',
      imgSrc: 'iti-thumb.jpg',
      link: 'https://yuvrajgroupofinstitute.com/ypi',
      description: 'The Yuvraj Pvt. ITI offers Electrician vocational training program aimed at equipping students with technical skills for various trades in the industry.'
    }
  ];

  const ramaColleges = [
    {
      name: 'Rama College of Nursing (ANM & GNM) Kutabpur',
      imgSrc: 'rcn-thumb.jpg',
      link: 'https://ramagroupofinstitute.com/rcn',
      description: 'Rama Nursing College offers programs for ANM & GNM, providing training in nursing and healthcare services, aimed at producing skilled healthcare professionals.'
    },
    {
      name: 'Rama College of Education, Kutabpur',
      imgSrc: 'rce-thumb.jpg',
      link: 'https://ramagroupofinstitute.com/rce',
      description: 'Rama College of Education offers courses in teacher training, preparing students to become educators with strong pedagogical skills.'
    },
    {
      name: 'Rama Sr. Sec. School Kutabpur',
      imgSrc: 'rps-thumb.jpg',
      link: 'https://ramagroupofinstitute.com/rsss',
      description: 'Rama Sr. Sec. School offers a well-rounded education with a focus on academic excellence, extracurricular activities, and moral development.'
    },
    {
      name: 'Rama Pvt. ITI Kutabpur',
      imgSrc: 'riti-thumb.jpg',
      link: 'https://ramagroupofinstitute.com/riti',
      description: 'Rama Pvt. ITI provides vocational courses in various technical fields, designed to impart industry-relevant skills to students.'
    }
  ];

  return (
    <div className="home-container">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-overlay">
          <h2 className="hero-title">About Our Organization</h2>
          <p className="hero-description">
            Rama Shiksha Samiti, Kutabpur, Kaithal
            <br />
            A Registered Society (Regd in 1999), Rama Group of Institute is run
            by Rama Shiksha Samiti, situated at Village Kutabpur (Teh. & Distt.
            Kaithal) 8 KM away from Kaithal on Bhanpura Road.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Why Our Group Section */}
        <section className="eduversita-section">
          <h2>Why Choose Our Group of Institutes</h2>
          <p>
            Yuvraj Group of Institutes offers a unique combination of flexibility,
            quality, global exposure, expertise, support, and certification to ensure
            the best learning experience.
          </p>

          <div className="icon-boxes">
            <div className="icon-box">
              <i className="fas fa-calendar-alt"></i>
              <h3>Flexibility</h3>
              <p>
                Flexible schedules to fit your lifestyle.
              </p>
            </div>
            <div className="icon-box">
              <i className="fas fa-star"></i>
              <h3>Quality</h3>
              <p>Top-tier education with experienced faculty and industry-driven curriculum.</p>
            </div>
            <div className="icon-box">
              <i className="fas fa-globe"></i>
              <h3>Global Exposure</h3>
              <p>Experience a multicultural learning environment with global outreach.</p>
            </div>
            <div className="icon-box">
              <i className="fas fa-users"></i>
              <h3>Expertise</h3>
              <p>Industry professionals providing real-world knowledge in the classroom.</p>
            </div>
            <div className="icon-box">
              <i className="fas fa-headset"></i>
              <h3>Support</h3>
              <p>Comprehensive student support to guide you throughout your educational journey.</p>
            </div>
            <div className="icon-box">
              <i className="fas fa-certificate"></i>
              <h3>Certified</h3>
              <p>Recognized certifications that enhance your skills and career prospects.</p>
            </div>
          </div>
        </section>

        {/* College Sections */}
       
        <CollegeSection title="Rama Group of Institutes, Kutabpur" colleges={ramaColleges} />
        <CollegeSection title="Yuvraj Group of Institutes, Batta" colleges={yuvrajColleges} />
        {/* View Section */}
        <section className="view">
          <h3>Our Vision</h3>
          <p>
            Both Society & Trust keeping in view
            <br />
            <strong>THE NATIONAL TARGET</strong>
            <br />
            <em>“EDUCATION FOR ALL”</em>
            <br />
            <em>“HEALTH FOR ALL”</em>
            <br />
            <em>“SPORTS FOR ALL”</em>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Home;
